import { ProjectInfo, ProjInfoProps } from '../../../models/project/project-info.model';
import { ProjectValidationUnit } from '../../../models/data-structures/project-validation';
import { ValidationInterface } from '../validation.interface';

export class ProjectInfoValidation implements ValidationInterface {
  /** The current project info obj that is being validated */
  projectInfo: ProjectInfo;

  /**
   * Sets the project info obj that will be used for validation
   * @param projectInfo will be used to set the current project info obj
   */
  constructor(projectInfo: ProjectInfo) {
    if (!projectInfo) {
      throw Error('unable to validate project info');
    }
    this.projectInfo = new ProjectInfo(projectInfo);
  }

  /**
   * Get a validation unit containing the validation data for the current project info obj
   */
  getValidation(): ProjectValidationUnit {
    const validationUnit = new ProjectValidationUnit();
    if (this.projectInfo.title) {
      validationUnit.setValid(ProjInfoProps.title);
    } else {
      validationUnit.setInvalid(ProjInfoProps.title,
        [ProjInfoError.MissingTitle]);
    }
    return validationUnit;
  }

  /**
   * returns a boolean that determines if the current project info obj is valid
   */
  isValid(): boolean {
    return this.getValidation().isValid;
  }
}

/**
 * An enum that contains errors for project info validation
 */
enum ProjInfoError {
  MissingTitle = 'VALIDATION.MISSING_TITLE',
}
